import Vue from 'vue';
import uclQuiz from './ucl-quiz/ucl-quiz.vue';

Vue.component('ucl-quiz', uclQuiz);
